import UrlParam from '~/common/utils/urlParam.js';
import DeviceDetection from '~/common/utils/deviceDetection.js';

// phone numbers
export const SALES_PHONE_NUMBER_FORMATTED = '(800) 820-8210'; // If this number ever changes, also update it in /client/index.html
export const SALES_PHONE_NUMBER_UNFORMATTED = '8008208210';

// offer suite plans consts
export const PLAN_TERM_MONTHLY = 'monthly';
export const PLAN_TERM_ANNUAL = 'annual';
export const TRUE_SOLO_EXTENSION = 1;
export const SOLO_PLUS_EXTENSION = 3;
export const PARTNER_EXTENSION = 6;
export const SMALL_BUSINESS_EXTENSION = 'Unlimited';
export const DEFAULT_EXTENSION = SOLO_PLUS_EXTENSION;
export const TRUE_SOLO_FORWARD_NUMBERS = 1;
export const DEFAULT_FORWARD_NUMBERS = 'Multiple';
export const TRUE_SOLO_USERS = 1;
export const DEFAULT_USERS = 'Unlimited';
export const BASE_ODOMETER_REEL = '0123456789';
// offer suite discount amount text
export const BASE_ANNUAL_DISCOUNT_PERCENTAGE = UrlParam('ghOp') ? `${UrlParam('ghOp')}%` : '20%';
// saving this for record
export const OFFER_SUITE_NO_ANNUAL = 'ad188a9b-097d-4478-9f27-85e7c37f38cf';
export const OFFER_SUITE_ANNUAL = 'E5E48C3A-9E93-4350-A974-36E18D27F1D0';
export const NEW_OFFER_SUITE_ANNUAL = '1EF20CD7-F1D3-435C-A5C2-61F5AFDFBE7B';
export const OFFER_SUITE_DEFAULT = OFFER_SUITE_ANNUAL;
export const OFFER_SUITE_WITH_TRUE_SOLO = '564C8BF8-8B47-4B0A-8900-FF505AB3D5E5'; // GOTOCOM-6035 :: Old-'1A6CB3B0-2D4A-4696-9976-2291581EC0FC'; // GOTOCOM-6255 :: Old ID: '0E7EF16C-6D24-4365-9F7F-A415ED67207E'; Oldest: 'B92CC396-0DA6-46C6-BFFD-DCDA85C472CC';

// convert to paid store consts
export const USER_LOGIN_VERSION = 4;
export const USER_LOGIN_GRANT_TYPE = 'password';
export const USER_LOGIN_PRODUCT_GUID = '9b1b8c63-1354-2078-e053-0100007f2fee';

// trial sign up consts
export const OFFER_SUITE_TRIAL = '3E1777E1-C207-4C97-8869-B793E887D436';
export const OFFER_ID_TRIAL = '842C4C5D-D0B3-4310-A11D-1E4460B73086';
export const TRIAL_PRODUCT_GUID = '9b1b8c63-1354-2078-e053-0100007f2fee';
export const TRIAL_PRODUCT_DESC = 'Grasshopper';

// abandonment cart program
export const ABANDOMENT_CART_PROGRAM_TRAIL = 'GH_Global_EN_TRG_Lead__Promo_Abandoned Trial';
export const ABANDOMENT_CART_PROGRAM_PURCHASE = 'GH_Global_EN_TRG_Lead__Promo_Abandoned Cart';
export const RUBY_LEAD_PROGRAM = 'Ruby Marketplace Leads';

// ruby signup program
export const RUBY_SIGNUP_PROGRAM = '7014P0000016gi6';

// responsive breakpoint consts
export const BREAKPOINT_SMALL = { name: 'small', value: 768 };
export const BREAKPOINT_MEDIUM = { name: 'medium', value: 992 };
export const BREAKPOINT_MEDIUM_LARGE = { name: 'medium-large', value: 1024 };
export const BREAKPOINT_LARGE = { name: 'large', value: 1200 };

// promo codes
export const PROMO_CODE_COOKIE_NAME = 'promo';
export const PROMO_CODE_MODAL_VIEWED_COOKIE_NAME = 'promoModalViewed';
export const PROMO_CODE_MODAL_CLOSED_COOKIE_NAME = 'promoBannerClosed';
export const PROMO_CODE_ANNUAL_ONLY_STRING = 'ANNUALONLY |';
export const PROMO_CODE_MONTHLY_ONLY_STRING = 'MONTHLYONLY |';
export const PROMO_COUPON_25 = '25dollars';
export const PROMO_COUPON_75 = '75dollars';
export const PROMO_COUPON_TRIAL_EXPIRED = 'try75recycledflex';
export const PROMO_COUPON_ANNUAL_INCENTIVE = 'annual75flex';
export const PROMO_COUPON_MONTHLY_15 = 'monthly15';
export const PROMO_MAX_AMOUNT_ALLOWED = 75;
export const PROMO_MAX_AMOUNT_ALLOWED_MONTHLY = 30;

// flow step consts
export const FLOW_STEP_PLANS = 'plans';
export const FLOW_STEP_NUMBERS = 'numbers';
export const FLOW_STEP_BILLING = 'billing';

// path consts
// general paths
export const PATH_PLANS = '/plans';
export const PATH_NUMBERS = '/numbers';
export const PATH_LOCAL_RECOMMEND = '/numbers/local-recommend';
export const PATH_LOCAL_SEARCH = '/numbers/local-search';
export const PATH_TOLL_FREE = '/numbers/toll-free';
export const PATH_CUSTOM_TOLL_FREE = '/numbers/custom-toll-free';
export const PATH_TRANSFER_CURRENT_NUMBER = '/numbers/transfer/current-number';
export const PATH_CONFIRM_NUMBER_TRANSFER = '/numbers/transfer/confirm-current-number-transfer';
export const PATH_BILLING = '/billing';
export const PATH_PENDING = '/pending';
// trial signup paths
export const PATH_TRIAL_NUMBERS = '/trial-numbers';
export const PATH_TRIAL_SIGNUP = '/trial-signup';
export const PATH_TRIAL_SIGNUP_SUCCESS = '/trial-signup-success';
export const PATH_TRIAL_BLOCKER = '/trial-block';
export const PATH_EXPIRED_TRIAL_BLOCKER = '/expired/trial';
// convert to paid paths
export const PATH_TRIAL_LOGIN = '/plans/trial';
export const PATH_TRIAL_UPGRADE = '/billing/trial';
export const PATH_ORDER_CONFIRMATION = '/order-confirmation';
export const PATH_SIGNUP_SUCCESS = '/signup-success';
// ruby flow view
export const PATH_RUBY = '/ruby';
// annual upgrade view
export const PATH_ANNUAL_UPGRADE = '/annual-upgrade';
// signed in view
export const PATH_SIGNED_IN = '/signed-in';

// device types
export const DEVICE_MOBILE_IOS = 'ios mobile touch-screen';
export const DEVICE_MOBILE_ANDROID = 'android mobile touch-screen';
export const DEVICE_MOBILE_OTHER = 'mobile touch-screen';
export const DEVICE_TABLET_IOS = 'ios tablet touch-screen';
export const DEVICE_TABLET_OTHER = 'tablet touch-screen';
export const DEVICE_DESKTOP_MAC = 'mac desktop';
export const DEVICE_DESKTOP_WINDOWS = 'windows desktop';
export const DEVICE_DESKTOP_OTHER = 'desktop';

// cards types array
export const CARD_TYPE_OBJ = { '001': 'visa', '002': 'Master_Card', '003': 'amex' };

// trial allowed countries
// US, CANADA, COSTA RICA
export const TRIAL_ALLOWED_COUNTRIES = ['US', 'CA', 'PR', 'HU', 'GT'];
export const TRIAL_MAX_AGE_EXPIRY_DATE = 19;
export const TRIAL_MAX_AGE_FTAGE = 28;

export const SIGNUP_ALLOWED_COUNTRIES = TRIAL_ALLOWED_COUNTRIES;

export const IS_PRODUCTION = window.location.hostname === 'signup.grasshopper.com';

// flexframe urls'
export const FLEXFRAME_URL = IS_PRODUCTION ? 'https://flex.cybersource.com/cybersource/assets/microform/0.11/flex-microform.min.js' : 'https://testflex.cybersource.com/cybersource/assets/microform/0.11/flex-microform.min.js';
export const DEVICE_FINGERPRINT_URL = 'https://h.online-metrix.net/fp/';
export const DEVICE_FINTERPRINT_ORG_ID = IS_PRODUCTION ? 'k8vif92e' : '1snn5n9w';

// flexframe constants
export const FLEX_NUMBER_FIELD_TYPE = 'number';
export const FLEX_CVC_FIELD_TYPE = 'securityCode';
export const FLEX_FIELDS = [FLEX_NUMBER_FIELD_TYPE, FLEX_CVC_FIELD_TYPE];
export const FLEX_CREATE_TOKEN_ERRORS_ENUM = {
    NO_DATA_AVAILABLE: 'CREATE_TOKEN_NO_FIELDS',
    NO_DATA_FIELDS_AVAILABLE: 'CREATE_TOKEN_NO_FIELDS_LOADED',
    TIMEOUT: 'CREATE_TOKEN_TIMEOUT',
    DATA_ERROR: 'CREATE_TOKEN_VALIDATION_FIELDS',
    INVALID_PARAMS: 'CREATE_TOKEN_VALIDATION_PARAMS',
    VALIDATION_ERROR: 'CREATE_TOKEN_VALIDATION_SERVERSIDE'
};

export const MAPPED_FLEX_TOKEN_ERRORS_ENUM = {
    INVALID_TOKEN: 'INVALID_TOKEN',
    FIELDS_ERROR: 'FIELDS_ERROR',
    NO_VALUES_ERROR: 'NO_VALUES_ERROR',
    EXP_DATE_ERROR: 'EXP_DATE_ERROR'
};

/**
 * Map each signup env urls to the marketing env urls
 * @param Array urls
 * @param Number Fallback Index
 */
const foundUrlFromHostname = (urls, fallbackIndex) => {
    const foundUrl = urls.find((array) => {
        return fallbackIndex ? array[0] === window.location.hostname || array[fallbackIndex] === window.location.hostname : array[0] === window.location.hostname;
    });

    if (fallbackIndex) {
        return foundUrl && foundUrl[fallbackIndex + 1] ? foundUrl[fallbackIndex + 1] : null;
    }

    return foundUrl && foundUrl[1] ? foundUrl[1] : null;
};

/**
 * external URL's
 * @todo Move this into chef, and use webpack parameters or SSR to bring thoses values to the front
 */
export const MARKETING_SITE_BASE_URL = () => {
    const urls = [
        ['signup.us-dev.ghus-aws.com', 'review.signup.grasshopper.com', 'https://rc.grasshopper.com'],
        ['signup.us-stg.ghus-aws.com', 'gamma.signup.grasshopper.com', 'https://staging.grasshopper.com'],
        ['signup.grasshopper.com', 'signup.grasshopper.com', 'https://grasshopper.com'],
        ['localhost', 'localhost', 'https://rc.grasshopper.com']
    ];
    return foundUrlFromHostname(urls, 1) || 'https://grasshopper.com';
};

export const PATH_PRODUCT_LOGIN_BASE_URL = () => {
    const urls = [
        ['signup.us-dev.ghus-aws.com', 'review.signup.grasshopper.com', 'https://portal.us-stg.ghus-aws.com'],
        ['signup.us-stg.ghus-aws.com', 'gamma.signup.grasshopper.com', 'https://portal.us-stg.ghus-aws.com'],
        ['signup.grasshopper.com', 'signup.grasshopper.com', 'https://portal.us.grasshopper.com'],
        ['localhost', 'localhost', 'https://portal.us-stg.ghus-aws.com']
    ];
    return foundUrlFromHostname(urls, 1) || 'https://portal.us.grasshopper.com';
};

export const PATH_PRODUCT_LOGIN_BASE_UAP_URL = () => {
    // Because of the configuration, we use staging on dev, not https://admin.dev.gtc.goto.com/
    const urls = [
        ['signup.us-dev.ghus-aws.com', 'https://admin.staging.gtc.goto.com/'],
        ['signup.us-stg.ghus-aws.com', 'https://admin.staging.gtc.goto.com/ '],
        ['signup.grasshopper.com', 'https://admin.goto.com'],
        ['localhost', 'https://admin.staging.gtc.goto.com/ ']
    ];

    return foundUrlFromHostname(urls) || 'https://admin.goto.com';
};

export const PATH_PROFILE_URL = () => {
    const urls = [
        ['signup.us-dev.ghus-aws.com', 'review.signup.grasshopper.com', 'https://nuui.us-stg.ghus-aws.com'],
        ['signup.us-stg.ghus-aws.com', 'gamma.signup.grasshopper.com', 'https://nuui.us-stg.ghus-aws.com'],
        ['signup.grasshopper.com', 'signup.grasshopper.com', 'https://nuui.us.grasshopper.com'],
        ['localhost', 'localhost', 'https://nuui.us-stg.ghus-aws.com']
    ];
    return foundUrlFromHostname(urls, 1) || 'https://nuui.us.grasshopper.com';
};


export const PATH_APPS_PAGE = `${MARKETING_SITE_BASE_URL()}/apps/customer/`;
export const PATH_MARKETING_PRICING = `${MARKETING_SITE_BASE_URL()}/pricing/`;
export const PATH_RUBY_OFFER_PAGE = `${MARKETING_SITE_BASE_URL()}/offer/ruby/new-tb`;
export const PATH_RUBY_TERMS_AND_CONDITIONS_PAGE = 'https://www.goto.com/company/legal/terms-and-conditions';
export const PATH_PRODUCT_LOGIN = `${PATH_PRODUCT_LOGIN_BASE_URL()}/login.aspx`; // prod: 'https://portal.us.grasshopper.com/login.aspx'
export const PATH_MARKETING_CONTACT_PAGE = `${MARKETING_SITE_BASE_URL()}/contact/`;
export const PATH_TRANSUNION_OFFER_PAGE = `${MARKETING_SITE_BASE_URL()}/offer/transunion`;
export const PATH_LEGALZOOM_OFFER_PAGE = `${MARKETING_SITE_BASE_URL()}/offer/legalzoom`;
export const PATH_RUBY_SPECIAL_OFFER_PAGE = `${MARKETING_SITE_BASE_URL()}/offer/ruby3125`;
export const PATH_IOS_DOWNLOAD_PAGE = 'https://itunes.apple.com/us/app/grasshopper/id579356813';
export const PATH_ANDROID_DOWNLOAD_PAGE = 'https://play.google.com/store/apps/details?id=com.grasshopper.dialer';
export const PATH_DESKTOP_DOWNLOAD = () => {
    const device = DeviceDetection();
    if (device === DEVICE_MOBILE_IOS || device === DEVICE_DESKTOP_MAC || device === DEVICE_TABLET_IOS) {
        return 'https://dl.grasshopper.com/Grasshopper.dmg';
    }
    return 'https://dl.grasshopper.com/Grasshopper.exe';
};

export const RUBY_PROMO_CODES = ['30', '50'];

// reCaptcha actions
// "Actions might contain only alphanumeric characters, slashes, and underscores. Actions must not be user-specific.""
// Source: https://developers.google.com/recaptcha/docs/v3#actions
export const RECAPTCHA_ACTION = {
    GH_TRIAL_START: 'GH_TRIAL_START'
};

// GA event environments
export const ENVIRONMENT = {
    production: 'prod',
    test: 'review',
    dev: 'review',
    development: 'dev',
    staging: 'gamma'
};

// Selected Number Types for GA events
export const SELECTED_NUMBER_TYPE = {
    Local: 'local number',
    Transfer: 'port number',
    'Toll Free': 'toll free',
    'Custom Toll Free': 'toll free'
};

// Hardcoded Launch Darkly Flags
export const PLANS_PRICE_INCREASE_ENABLED = true;
export const UAP_LOGIN_ENABLED = false;
export const LMI_LOGIN_FLOW_ENABLED = false;

// Plans
export const TRUE_SOLO = 'True Solo';
export const SOLO_PLUS = 'Solo Plus';
export const PARTNER = 'Partner';
export const SMALL_BUSINESS = 'Small Business';

// Flag to use AwsWaf Integration Call for Login APIS
export const AWS_WAF_INTEGRATION = true;
